module.exports = __webpack_public_path__ + "img/waistband_width.9cca274e.png";